import React from 'react'
import { Box, Typography } from '@mui/material'

const Footer = () => {
  return (
    <Box
      sx={{
        height: '100%',
        backgroundColor: '#FFF',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'end',
        justifyContent: 'end',
        paddingRight: '15px',
      }}>
      <Typography
        variant='caption'
        component='span'
        sx={{ fontWeight: 'bold' }}>
        Powered By:&nbsp;
      </Typography>
      <Typography
        variant='body2'
        component='span'
        sx={{ fontWeight: 'bold', color: 'blue' }}>
        SUM IT&nbsp;
      </Typography>
      <Typography variant='body2' component='span' sx={{ fontWeight: 'bold' }}>
        Consultancy Services Private Limited
      </Typography>
    </Box>
  )
}

export default Footer
